const blackListProps = {
	isExist: true,
	spinnerColor: true,
	spinnerBackGroundColor: true,
	isLoading: true,
	divide: true,
	isStartAdornmentExist: true,
	checkboxSize: true,
	hoverColorIconButton: true,
	withoutMaxWidth: true,
	isHover: true,
	iconSize: true,
	errorTextAbsolute: true,
	backgroundColor: true,
	deleteIconColor: true,
	deleteIconSize: true,
	isTag: true,
	onHandleOption: true,
	hasError: true,
	customColor: true,
};

export default blackListProps;
